import React, { useState } from "react";
import "./CreateEditModal.css";
import Input from "../../../../components/reusable-input/Input";
import MultiSelect from "../../../../components/multi-select/MultiSelect";

type Member = {
  id: string;
  name: string;
};

type Props = {
  mode: "create" | "edit";
  initialName?: string;
  initialMembers?: Member[];
  allMembers: Member[];
  originalMembers?: Member[];
  onClose: () => void;
  onSubmit: (
    groupName: string,
    members: Member[],
    originalMembers?: Member[],
  ) => void;
};

const CreateEditModal: React.FC<Props> = ({
  mode,
  initialName = "",
  initialMembers = [],
  allMembers,
  originalMembers,
  onClose,
  onSubmit,
}) => {
  const [groupName, setGroupName] = useState(initialName);
  const [members, setMembers] = useState<Member[]>(initialMembers);

  const handleSubmit = () => {
    onSubmit(groupName, members, originalMembers);
  };

  return (
    <div className="group-modal-overlay">
      <div className="group-modal">
        <h3>{mode === "create" ? "Create New Group" : "Edit Group"}</h3>
        <div className="group-model-content">
          {/* Group Name input */}
          <div className="group-form-group">
            <Input
              type="text"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              placeholder="Enter Name"
              label="Group Name"
              required={true}
            />
          </div>

          {/* ✅ Use MultiSelect */}
          <MultiSelect
            allMembers={allMembers}
            selectedMembers={members}
            onChange={setMembers}
          />
        </div>

        <div className="group-modal-actions">
          <button className="group-btn cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="group-btn submit"
            onClick={handleSubmit}
            disabled={!groupName || members.length === 0}
          >
            {mode === "create" ? "Submit" : "Update"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateEditModal;
